/** angular */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
/** end angular */

/** models */
import { DsLinearFormInstance } from '../models/ds-linear-form-instance';
import { BydModel, BydGenerateParams } from '@sixense/byd-core-service';
/** end models */

/** services */
import { BydRhsAbstractService } from '../../../shared/services/byd-rhs-abstract.service';
/** end services */

/** interfaces */
import { DsLinearFormInstanceFiltersInterface } from '../interfaces/ds-linear-form-instance-filters.interface';
import { DsLinearFormInstanceInterface } from '../interfaces/ds-linear-form-instance.interface';
/** end interfaces */

@Injectable({
  providedIn: 'root',
})
export class DsLinearFormInstancesService extends BydRhsAbstractService {
  /**
   * Implement inherited abstract member 'path' from BydRhsAbstractService
   */
  public path: string;

  /**
   * Gets the list of linear form instances.
   *
   * @param projectId The current project id
   * @param filters The object of accepted filters properties
   * @param elementsPerPage The number of element to receive per page
   * @param pageIndex The page index to receive
   * @returns Observable<BydModel<DsFormInstance>>
   */
  public getFormInstances(
    projectId: number,
    filters?: DsLinearFormInstanceFiltersInterface,
    elementsPerPage = 10,
    pageIndex = 0
  ): Observable<BydModel<DsLinearFormInstance>> {
    this.path = `/v1/dslinear/projects/${projectId}/instances`;
    const params = BydGenerateParams<DsLinearFormInstanceFiltersInterface>(filters);
    const headers = this.bydRhsHeadersService.setHeadersWithPagination(elementsPerPage, pageIndex);
    return this.getModels<DsLinearFormInstance>({ headers, params });
  }

  /**
   * Create DsFormInstance instance.
   *
   * @param  jsonObject The flat json object.
   * @returns an `DsFormInstance` instance.
   */
  public createNewInstance(jsonObject: DsLinearFormInstanceInterface): DsLinearFormInstance {
    return new DsLinearFormInstance(jsonObject);
  }
}
